"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.InspectorContainer = exports.Countwrap = exports.Counter = exports.Action = exports.Actions = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Actions =
/*#__PURE__*/
(0, _styled.default)("pre", {
  target: "ef9a6e10"
})({
  flex: 1,
  margin: 0,
  padding: '8px 2px 20px 0',
  overflowY: 'auto',
  color: '#666'
});
exports.Actions = Actions;
var Action =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "ef9a6e11"
})({
  display: 'flex',
  padding: '3px 3px 3px 0',
  borderLeft: '5px solid transparent',
  borderBottom: '1px solid transparent',
  transition: 'all 0.1s',
  alignItems: 'start'
});
exports.Action = Action;
var Counter =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "ef9a6e12"
})({
  margin: '0 5px 0 5px',
  backgroundColor: '#777777',
  color: '#ffffff',
  padding: '1px 5px',
  borderRadius: '20px'
});
exports.Counter = Counter;
var Countwrap =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "ef9a6e13"
})({
  paddingBottom: 2
});
exports.Countwrap = Countwrap;
var InspectorContainer =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "ef9a6e14"
})({
  flex: 1,
  padding: '0 0 0 5px'
});
exports.InspectorContainer = InspectorContainer;
var Wrapper =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "ef9a6e15"
})({
  flex: 1,
  display: 'flex',
  position: 'relative',
  height: '100%'
});
exports.Wrapper = Wrapper;